// Currency + number formatting helpers (Bahasa Indonesia).

export function formatRupiah(value) {
  if (value == null) return "-";
  return "Rp" + new Intl.NumberFormat("id-ID").format(value);
}

// Compact form like "Rp1,8 jt" used on cards.
export function formatRupiahShort(value) {
  if (value == null) return "-";
  if (value >= 1_000_000) {
    const juta = value / 1_000_000;
    const str = juta % 1 === 0 ? juta.toString() : juta.toFixed(1).replace(".", ",");
    return `Rp${str} jt`;
  }
  if (value >= 1_000) {
    return `Rp${Math.round(value / 1000)} rb`;
  }
  return "Rp" + value;
}

export function formatDistance(km) {
  if (km == null) return "-";
  return `${km} km`;
}
